<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-toolbar-title class="indigo--text"
                >Seleccione sus opciones</v-toolbar-title
              >
            </v-toolbar>
            <botones-acuerdo-impresion
              :key="botonesUsuario"
            ></botones-acuerdo-impresion>
            <grid-ultimo-acuerdo-impresion
              :key="ultimoAcuerdo"
            ></grid-ultimo-acuerdo-impresion>
            <!-- TABLA DOCUMENTO -->
            <template>
              <grid-documento-diario-acuerdo
                :key="gridDocumento"
                :rowsTable="rowsTable"
              ></grid-documento-diario-acuerdo>
            </template>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import BotonesAcuerdoImpresion from "@/modules/impresion/views/acuerdo/BotonesAcuerdoImpreion.vue";
import GridUltimoAcuerdoImpresion from "@/modules/impresion/views/acuerdo/GridUltimoAcuerdoImpresion.vue";
import GridDocumentoDiarioAcuerdo from "@/modules/impresion/views/acuerdo/GridDocumentoDiarioAcuerdo.vue";
import VisitaSubTab from "@/modules/visitas/views/VisitaSubTab.vue";

export default {
  name: "menu-sub-proceso-impresion",

  components: {
    GridDocumentoDiarioAcuerdo,
    BotonesAcuerdoImpresion,
    GridUltimoAcuerdoImpresion,
  },

  props: {
    tabSelected: "",
  },

  data() {
    return {
      text: "En construccion",
      loading: false,
      proveedor: {},
      rowsTable: [20],
      tabs: ["Acuerdo", "Progreso", "Contingencia", "Calidad"],
      contratoId: "",
      tabSelect: "",
      activeTab: "",
      index: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      filter: false,
      usuarioLogged: "",
      botonesUsuario: 0,
      ultimoAcuerdo: 10,
      gridDocumento: 20,
      idEstado: "",
    };
  },

  mounted() {
    this.usuarioLogged = this.$store.getters.userLogged;
  },
  created() {},

  methods: {
    reloadAcuerdo() {
      this.ultimoAcuerdo += 11;
    },
    reloadBoton() {
      this.botonesUsuario += 1;
    },
    reloadDocumento() {
      this.gridDocumento += 22;
    },
    selected(tab) {
      this.tabSelect = tab;
    },
    filterDoc() {
      this.filter = true;
    },
  },
};
</script>
